//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';

function Page() {
  const improveYourSleep = useStore((state) => state.improveYourSleep);
  const setImproveYourSleep = useStore((state) => state.setImproveYourSleep);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.improveYourSleep.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={improveYourSleep}
          onChange={(value) => {
            setImproveYourSleep(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'improve-your-sleep',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'No, i sleep well'}>
            {t('onboarding.improveYourSleep.options.sleepWell')}
          </Option>
          <Option value={'Waking up tired'}>
            {t('onboarding.improveYourSleep.options.tired')}
          </Option>
          <Option value={'Waking up during nights'}>
            {t('onboarding.improveYourSleep.options.duringNights')}
          </Option>
          <Option value={'Insomnia'}>{t('onboarding.improveYourSleep.options.insomnia')}</Option>
          <Option value={'Difficulty falling asleep'}>
            {t('onboarding.improveYourSleep.options.fallingAsleep')}
          </Option>
          <Option value={'Lack of sleep schedule'}>
            {t('onboarding.improveYourSleep.options.sleepSchedule')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
